import React from "react";
import styled from "styled-components";
import { FaCaretDown } from "react-icons/fa";

const TournamentSelect = ({ tournaments, selectedId, onChange }) => {
  const sorted = [...tournaments].sort((a, b) => {
    const numA = parseInt(a.name.match(/\d+/)?.[0] || "0");
    const numB = parseInt(b.name.match(/\d+/)?.[0] || "0");
    return numB - numA;
  });

  return (
    <SelectContainer>
      <Select value={selectedId || ""} onChange={onChange}>
        {sorted.map((tournament) => (
          <option key={tournament.tournamentId} value={tournament.tournamentId}>
            {tournament.name}
          </option>
        ))}
      </Select>
      <Caret>
        <FaCaretDown />
      </Caret>
    </SelectContainer>
  );
};

const SelectContainer = styled.div`
  position: relative;
  width: 100%;
`;

const Caret = styled.div`
  position: absolute;
  top: 50%;
  right: 1rem;
  transform: translateY(-50%);
  pointer-events: none;
  color: var(--v-fg-muted);
  font-size: 12px;
`;

const Select = styled.select`
  width: 100%;
  padding: 0.7rem 1rem;
  background: rgba(255, 255, 255, 0.04);
  color: var(--v-fg);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 12px;
  font-family: var(--v-font-body);
  font-size: 13px;
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  cursor: pointer;
  outline: none;
  transition: border-color 0.15s ease;

  &:focus {
    border-color: var(--v-mint);
  }

  option {
    background: #1a1a1a;
    color: var(--v-fg);
  }
`;

export default TournamentSelect;
